import React from "react";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-black text-white pt-20 pb-10 text-sm">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 text-center lg:text-left items-start">

        {/* 1. Usługi */}
        <div>
          <h4 className="text-lg font-semibold mb-3 text-orange-500">Usługi</h4>
          <ul className="space-y-1 text-gray-400">
            <li>Pirotechnika sceniczna</li>
            <li>Multimedia</li>
            <li>Auta do ślubu</li>
            <li>Dekoracja światłem</li>
            <li>Ciężki dym</li>
            <li>Nagłośnienie plenerowe</li>
          </ul>
        </div>

        {/* 2. Slogan + Odznaka */}
        <div className="flex flex-col items-center lg:items-start">
          {/* Insert the DJ Kusy banner here */}
          <a href="https://www.weselezklasa.pl/ogloszenia-weselne/dj-wodzierej-kusy,61015/" target="_blank" title="DJ & Wodzirej Kusy"><img src="https://www.weselezklasa.pl//banery/Weselezklasa/logo104x128przezroczystetlobialewypelnienie.png" 
              alt="DJ & WODZIEREJ KUSY" 
              border="0" 
            />
          </a>
          <h3 className="text-2xl font-bold leading-snug mb-6 text-orange-500">
            Tworzymy <br />
            Wyjątkowe <br />
            Przyjęcia
          </h3>
          <a
            href="https://www.orlyrozrywki.pl/profile-905804-dj-kusy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:scale-105 transition-transform duration-300"
          >
            <img
              src="https://www.orlyrozrywki.pl/images/medals/905804/laureat300_gold_pl.png"
              alt="DJ Kusy - Orły Rozrywki"
              title="DJ Kusy - Rzeszów"
              className="w-[220px] h-[55px]"
            />
          </a>
        </div>

        {/* 3. Q&A + Social + Polityka */}
        <div>
          <h4 className="text-lg font-semibold mb-3 text-orange-500">Q&A</h4>
          <p>
            <a href="/pytania" className="text-gray-400 hover:text-orange-400 transition">
              Pytania i odpowiedzi
            </a>
          </p>
          <p className="mt-2">
            <a href="/polityka-prywatnosci" className="text-gray-400 hover:text-orange-400 transition">
              Polityka prywatności
            </a>
          </p>
          <div className="mt-6 flex justify-center lg:justify-start space-x-5 text-xl">
            <a href="https://www.facebook.com/djkusy/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF className="hover:text-orange-400 transition" />
            </a>
            <a href="https://www.instagram.com/dj_kusy/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram className="hover:text-orange-400 transition" />
            </a>
            <a href="https://www.tiktok.com/@dj_kusy" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <FaTiktok className="hover:text-orange-400 transition" />
            </a>
          </div>
        </div>

        {/* 4. Kontakt */}
        <div>
          <h4 className="text-lg font-semibold mb-3 text-orange-500">Kontakt</h4>
          <p className="text-gray-400">7 dni w tygodniu, 24 godziny</p>
          <p className="mt-2">
            <a href="tel:+48690442187" className="text-orange-400 font-medium hover:underline">
              +48 690 442 187
            </a>
          </p>
          <p>
            <a href="mailto:biuro@djkusy.pl" className="text-orange-400 font-medium hover:underline">
              biuro@djkusy.pl
            </a>
          </p>
        </div>
      </div>

      {/* SEO (ukryty) */}
      <p className="sr-only" aria-hidden="false">
        DJ na wesele, wodzirej na wesele, DJ na imprezę firmową, DJ na studniówkę, DJ wesele Krosno, DJ Dębica, DJ Rzeszów, DJ Lublin.
      </p>

      {/* Copyright */}
      <div className="mt-6 text-center text-xs text-gray-600">
        © {new Date().getFullYear()} DJ KUSY. Wszelkie prawa zastrzeżone.
      </div>
      <div className="mt-2 text-center text-xs text-gray-500">
        Wykonanie: <span className="font-semibold">DigitalEra</span>. <a href="tel:+48722180005" className="hover:underline">+48 722 180 005</a>
      </div>
    </footer>
  );
};

export default Footer;
